export const accountSetup = {
  payments: {
    planUnavailableTitle: "غير متاح في باقتك",
    planUnavailableMessage:
      "خيار تحصيل المدفوعات من النزلاء عبر Stripe متاح فقط في باقات Standard وما فوقها. قم بترقية باقتك لتفعيل هذه الميزة والبدء في التحصيل مباشرةً دون وسطاء.",
  },
  modalConnection: {
    header: "ربط نظام PMS",
    loaderMessage: "جارٍ الحفظ، يرجى الانتظار.",
    selectPmsLabel: "اختر نظام PMS",
    selectPmsPlaceholder: "اختر نظام PMS",
    apiKeyLabel: "مفتاح API لـ {pms}",
    apiKeyPlaceholder: "أدخل مفتاح API",
    cancel: "إلغاء",
    save: "حفظ الاتصال",
    fieldRequired: "حقل مطلوب",
    selectPmsError: "اختر نظام PMS",
    apiKeyError: "يرجى إدخال مفتاح API",
    savedTitle: "تم حفظ الاتصال",
    savedMessage: "تم حفظ الاتصال بنجاح",
    saveFailMessage: "تعذّر حفظ الاتصال",
    errorTitle: "خطأ",
    serverError: "خطأ في الاتصال بالخادم",
  },
  subscription: {
    title: "اشتراكي",
    subtitle: "اطّلع على باقتك وطريقة الدفع والفوترة وأدرها.",
    statusActive: "نشط",
    // Cancelada pero todavía dentro de lo que ya pagó: ni «Activa» ni «Cancelada» a secas.
    statusCanceledValid: "ملغاة · نشطة حتى",
    validUntil: "نشطة حتى:",
    statusPaymentPending: "دفعة معلّقة",
    statusTrial: "فترة تجريبية",
    statusNone: "لا يوجد اشتراك نشط",
    intervalYearly: "باقة سنوية",
    intervalMonthly: "باقة شهرية",
    perMonthShort: "/شهر",
    nextRenewal: "التجديد القادم:",
    servicesIncluded: "الخدمات المشمولة",
    units: "وحدة | وحدات",
    perUnitSuffix: "/وحدة",
    serviceFallback: "خدمة",
    manageOpening: "جارٍ الفتح…",
    manageButton: "إدارة الاشتراك والفواتير",
    emptyText:
      "ليس لديك باقة نشطة بعد. اختر واحدة لبدء استقبال تسجيلات الوصول والمدفوعات.",
    buyPlan: "شراء باقة",
    types: {
      apartment: "شقة",
      hotel: "فندق",
      room: "غرفة",
      camping: "مخيّم",
      villa: "فيلا",
      chatbot: "استقبال بالذكاء الاصطناعي",
    },
  },
  purchased: {
    title: "المتاح في اشتراكك",
    subtitle: "الحصة المتعاقد عليها والاستخدام الحالي",
    accommodations: "أماكن الإقامة",
    empty: "لم تُنشئ أي أماكن إقامة بعد.",
    createProperty: "إنشاء عقار",
    adjust: "تعديل",
    loadError: "تعذّر تحميل المعلومات.",
    labels: {
      apartment: "شقة/شقق",
      hotel: "فندق (غرف)",
      hotelPack: "فندق (غرف) · #{id}",
      villa: "فيلات",
      camping: "مخيّمات",
      campingPack: "مخيّمات · #{id}",
      chatbot: "تراخيص Chatbot",
    },
    units: {
      unid: "وحدة",
      room: "غرفة",
      spots: "أماكن",
      licenses: "تراخيص",
    },
    types: {
      hotel: "فندق",
      camping: "مخيّم",
      villa: "فيلا",
      apartment: "شقة",
    },
    badge: {
      rooms: "{n} غرفة",
      spots: "{n} أماكن",
      unit: "وحدة واحدة",
    },
  },
  notifications: {
    title: "الإشعارات",
    description: "فعّل أو عطّل أتمتة المراسلة والتنبيهات.",
    loading: "جارٍ تحميل الإعدادات...",
    alwaysActive: "مفعّل دائمًا",
    active: "مفعّل",
    inactive: "غير مفعّل",
    hint:
      "ملاحظة: تُعرض بعض عمليات الأتمتة كمعلومات فقط لأنها جزء من التدفق القياسي للنظام.",
    loadError: "تعذّر تحميل الإعدادات.",
    saveError: "تعذّر حفظ التغيير. جارٍ إعادة المحاولة...",
    items: {
      whatsapp_booking_confirmation: {
        title: "تأكيد الحجز (واتساب)",
        description: "يرسل تلقائيًا قالب التأكيد عند تأكيد الحجز.",
      },
      email_checkin_sent: {
        title: "إشعارات بالبريد عند إرسال تسجيل الوصول",
        description:
          "يرسل بريدًا تلقائيًا عند اكتمال أو إرسال عملية تسجيل الوصول.",
      },
      whatsapp_checkin_link_auto: {
        title: "إرسال واتساب تلقائي لتسجيل الوصول أونلاين",
        description:
          "يرسل تلقائيًا رابط تسجيل الوصول أونلاين عبر واتساب عند الاقتضاء.",
      },
      checkin_link_send_policy: {
        title: "سياسة إرسال رابط تسجيل الوصول للحجوزات المباشرة",
        description:
          "حدّد ما إذا كان الرابط يُرسل دائمًا أو فقط عندما يكون الحجز مدفوعًا أو مدفوعًا جزئيًا.",
        options: {
          always: {
            label: "الإرسال دائمًا",
            description: "يرسل رابط تسجيل الوصول بغضّ النظر عن حالة الدفع.",
          },
          paid_or_partially_paid: {
            label: "المدفوع أو المدفوع جزئيًا فقط",
            description:
              "يرسل الرابط فقط إذا كان الحجز مدفوعًا كليًا أو جزئيًا. ينطبق على الحجوزات المباشرة فقط.",
          },
        },
      },
    },
  },
  wompi: {
    country: "كولومبيا",
    statusVerified: "متصل",
    statusPending: "غير مُوثّق",
    publicKeyLabel: "المفتاح العام",
    privateKeyLabel: "المفتاح الخاص",
    keepPrivateLabel: "الإبقاء على المفتاح الخاص المحفوظ (لا يُعرض لأسباب أمنية)",
    privatePlaceholderSaved: "•••••••••••• (محفوظ)",
    btnDisconnect: "قطع الاتصال",
    btnVerify: "توثيق الحساب",
    btnSave: "حفظ بيانات الاعتماد",
    merchantHeader: "تم اكتشاف التاجر",
    missingPublicKey: "المفتاح العام مفقود",
    missingPrivateKey: "المفتاح الخاص مفقود",
    savedOk: "تم حفظ بيانات الاعتماد بنجاح",
    saveError: "خطأ في حفظ بيانات الاعتماد",
    verifiedOk: "تم توثيق الحساب",
    notVerified: "لم يتم توثيق الحساب",
    verifyError: "خطأ في توثيق الحساب",
    disconnectConfirm: "هل أنت متأكد من قطع اتصال Wompi عن هذا النشاط التجاري؟",
    disconnectedOk: "تم قطع الاتصال بنجاح",
    disconnectError: "خطأ في قطع الاتصال",
  },
  pricelabs: {
    subtitle: "تحسين ديناميكي للأسعار",
    statusConnected: "متصل",
    statusDisconnected: "غير متصل",
    loading: "جارٍ تحميل الإعدادات...",
    emailLabel: "بريد PriceLabs الإلكتروني",
    emailPlaceholder: "your-email@pricelabs.com",
    importantTitle: "هام:",
    bullet1: "تأكّد من إعداد عقاراتك بالكامل",
    bullet2: "اختر الإعلانات التي تذهب إلى PriceLabs",
    bullet3:
      "ستُحدَّث الأسعار وفقًا لـ PriceLabs ولن يمكن تعديلها يدويًا من Wacheckin",
    btnConnect: "الاتصال والمزامنة",
    btnConnecting: "جارٍ الاتصال...",
    btnSync: "مزامنة",
    btnSyncing: "جارٍ المزامنة...",
    btnDisconnect: "قطع الاتصال",
    btnDisconnecting: "جارٍ قطع الاتصال...",
    emailRequired: "يرجى إدخال بريد PriceLabs الإلكتروني",
    emailRequiredTitle: "البريد الإلكتروني مطلوب",
    connectHeader: "الاتصال بـ PriceLabs؟",
    connectMessage:
      "سيتم ربط جميع عقاراتك وغرفك النشطة. ستتم مزامنة الأسعار والتوافر. وأي عقار/غرفة يُنشأ لاحقًا سيُرسل تلقائيًا.",
    connectAccept: "نعم، اتصل",
    cancel: "إلغاء",
    linkError: "خطأ في ربط الوحدات",
    emailNotFoundConnect:
      "أفاد PriceLabs بأن البريد الإلكتروني غير موجود. تحقّق من بريدك وحاول مجددًا.",
    emailInvalidTitle: "بريد PriceLabs الإلكتروني غير صالح",
    syncSuccess: "أصبحت عقاراتك الآن متصلة بـ PriceLabs.",
    syncSuccessTitle: "اكتملت المزامنة!",
    syncFail: "تعذّر إكمال المزامنة",
    errorTitle: "خطأ",
    emailNotFoundManual:
      "أشار PriceLabs إلى أن البريد الإلكتروني غير موجود. صحّح البريد وأعد المزامنة.",
    manualSuccess: "اكتملت العملية بنجاح.",
    manualSuccessTitle: "مزامنة يدوية",
    manualFail: "تعذّرت المزامنة مع PriceLabs",
    rejected: "رفضت PriceLabs {count} إعلان. {detail}",
    rejectedTitle: "تعذّرت المزامنة",
    nothingSent: "لم يُرسَل أي إعلان. تأكد من أن ما اخترته له سعر وعملة.",
    relinked: "{count} إعلان كان لا يزال مرتبطًا بحساب PriceLabs آخر: أُرسل بمعرّف جديد، لذا يظهر هناك كإعلان جديد.",
    relinkedTitle: "معرّف جديد",
    syncedAt: "تمت المزامنة · {when}",
    notSyncedYet: "متصل، لم يُرسل بعد",
    noneSelected: "لم تختر أي مكان إقامة. حدّد ما تريد إرساله إلى PriceLabs ثم زامن من جديد.",
    disconnectHeader: "قطع الاتصال بـ PriceLabs؟",
    disconnectMessage: "سيتم إلغاء ربط جميع عقاراتك من PriceLabs.",
    disconnectAccept: "نعم، اقطع الاتصال",
    disconnectedOk: "تم فصل حسابك عن PriceLabs",
    disconnectedTitle: "غير متصل",
    disconnectFail: "تعذّر قطع الاتصال بـ PriceLabs",
    noErrorsReported: "لا توجد أخطاء مُبلَّغ عنها.",
    listingPrefix: "الإعلان {id}: ",
    unknownError: "خطأ غير معروف",
    listTitle: "أي إعلانات تذهب إلى PriceLabs",
    listHint: "اختر ما تريد أن يديره PriceLabs. ما تتركه مطفأً يحتفظ بأسعاره وتحرّره بنفسك.",
    listCount: "{n} من {total} مختارة",
    listSearch: "ابحث عن مكان إقامة أو غرفة…",
    listRooms: "{n} غرف",
    listApartment: "شقة",
    listEmpty: "ليس لديك أماكن إقامة بعد.",
    listNoMatch: "لا يوجد مكان إقامة بهذا الاسم.",
    listNeedsCurrency: "العملة ناقصة",
    listNeedsRate: "خطة سعر ناقصة",
    btnConnectN: "اتصل وزامن | اتصل وزامن {n} | اتصل وزامن {n}",
    unitConnected: "{name} يذهب الآن إلى PriceLabs",
    unitDisconnected: "{name} لم يعد يذهب إلى PriceLabs",
    unitFail: "تعذّر التغيير. حاول مرة أخرى.",
    listLocked: "اربط حساب PriceLabs وستتمكّن هنا من اختيار الإعلانات التي يديرها.",
    listAll: "الكل",
    listNone: "لا شيء",
    btnSyncN: "مزامنة | مزامنة إعلان واحد | مزامنة {n} إعلانات",
    connectedOk: "تم ربط الحساب. اختر الآن الإعلانات التي تذهب إلى PriceLabs.",
    connectedTitle: "تم",
  },
};
